var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRed = function SvgArrowRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.837,
    height: 34.501
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ee3a43",
    strokeWidth: 4,
    d: "m1.517 1.304 13.684 15.948L1.517 33.204",
    "data-name": "Path 8"
  })));
};
export { SvgArrowRed as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNy44MzciIGhlaWdodD0iMzQuNTAxIiB2aWV3Qm94PSIwIDAgMTcuODM3IDM0LjUwMSI+DQogIDxwYXRoIGlkPSJQYXRoXzgiIGRhdGEtbmFtZT0iUGF0aCA4IiBkPSJNMTk1NC4wMS0yMTMuNmwxMy42ODQsMTUuOTQ4TDE5NTQuMDEtMTgxLjciIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xOTUyLjQ5MyAyMTQuOTA0KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZWUzYTQzIiBzdHJva2Utd2lkdGg9IjQiLz4NCjwvc3ZnPg0K";